import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersist({
  key: process.env.VUE_APP_PROJECT_KEY,
  storage: window.localStorage,
  modules: [],
});

export default new Vuex.Store({
  state: {
    settings: {},
    currentRaffle: null,
  },

  getters: {
    settings: ({ settings }) => settings,
    features: ({ settings }) =>
      (settings.modules || []).reduce(
        (a, e) => ({ ...a, [e.module]: e.active }),
        {}
      ),
    currentRaffle: ({ currentRaffle }) => currentRaffle,
  },

  mutations: {
    SET_SETTINGS(state, payload) {
      state.settings = payload;
    },

    SET_CURRENT_RAFFLE(state, payload) {
      state.currentRaffle = payload;
    },
  },

  actions: {
    setSettings({ commit }, payload) {
      commit("SET_SETTINGS", payload);
    },

    setCurrentRaffle({ commit }, payload) {
      commit("SET_CURRENT_RAFFLE", payload);
    },
  },

  modules: {},

  plugins: [vuexLocal.plugin],
});
